// Search params da tela de Usuários (/management/users): busca (?q=) e papel
// (?role=, o roleId efetivo) na URL via useTableSearch — o recorte sobrevive ao
// reload e pode ser linkado. A lista é filtrada no cliente; não há paginação
// nem ordenação na URL, só o mínimo que o useTableSearch exige.
import {
  normalizeTableSearch,
  serializeTableSearch,
  type TableSearchConfig,
} from "./lib/table-search";

export const USERS_TABLE: TableSearchConfig = {
  filterKeys: ["q", "role"],
  sortFields: ["name"],
  defaultSort: "name",
  defaultSortDir: "asc",
  pageSizes: [50],
  defaultPageSize: 50,
};

export function validateUsersSearch(raw: Record<string, unknown>) {
  return serializeTableSearch(normalizeTableSearch(raw, USERS_TABLE), USERS_TABLE);
}
